import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TableCellActionDataIn, TableColumnData } from "@app/models";
import { maxPaginationSize, tableDateFormat } from "./table.utils";

@Component({
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbstractGridComponent<T extends { id: number | string } & Record<string, unknown>> {
  @Input() stickyActionListColumn = false;
  @Input() columnDateFormat = tableDateFormat.full;
  @Input() maxPaginationSize = maxPaginationSize;
  @Input() columnData: TableColumnData[] = [];
  @Input() actionList: TableCellActionDataIn[] = [];
  @Input() loading: boolean;

  @Output() selectedRowsChange = new EventEmitter<(string | number)[]>();

  protected tableData: T[] = [];
  protected selectionMap = new Map<number | string, boolean>();
  protected isAllRowsSelected = false;

  constructor(protected datePipe: DatePipe) {}

  protected onAllRowsSelect(event: Event, isRowSelectable?: (row: unknown) => boolean): void {
    this.isAllRowsSelected = !!(event.target as HTMLInputElement).checked;

    if (this.isAllRowsSelected) {
      this.tableData.forEach((item) => {
        if (!isRowSelectable || isRowSelectable(item)) {
          this.selectionMap.set(item.id, true);
        }
      });
    } else {
      this.selectionMap.clear();
    }

    this.emitSelectedRowIds();
  }

  protected onRowSelect(item: T, event: Event): void {
    const isSelected = !!(event.target as HTMLInputElement).checked;

    if (isSelected) {
      this.selectionMap.set(item.id, true);
    } else {
      this.selectionMap.delete(item.id);
    }

    this.isAllRowsSelected = this.selectionMap.size === this.tableData.length && this.tableData.length > 0;

    this.emitSelectedRowIds();
  }

  protected emitSelectedRowIds(): void {
    const selectedIds: (string | number)[] = Array.from(this.selectionMap.keys());

    this.selectedRowsChange.emit(selectedIds);
  }

  protected normalizeTableData(columnData: TableColumnData[], tableData: T[], datePipe: DatePipe, columnDateFormat: string): T[] {
    if (columnData.length && tableData.length) {
      const specificColumns = columnData.filter((c) => c.dataType !== "number" && c.dataType !== "string");
      specificColumns.forEach((column) => {
        return tableData.map((item) => {
          if (item[column.key] && column.dataType === "date") {
            (item[column.key] as string) = datePipe.transform(item[column.key] as string, columnDateFormat);
          }

          return item;
        });
      });
    }

    return tableData;
  }
}
